import { camo } from './camo';
import { modern } from './modern';
import { patriotic } from './patriotic';
import { retro } from './retro';
import { traditional } from './traditional';
import { city } from './city';

export const basketball = {
  traditional,
  modern,
  retro,
  patriotic,
  camo,
  city,
};
